import ChartingBaseController from './charting_base_controller';

export default class extends ChartingBaseController {
  static values = { actions: { type: Array, default: [] } };

  execute(event) {
    const { checked } = event.target;

    this.applyActions(this.actionsValue, { value: checked, remove: !checked });
  }
}
